import { render, staticRenderFns } from "./UsefulContent.vue?vue&type=template&id=3389d472&scoped=true&"
import script from "./UsefulContent.vue?vue&type=script&lang=js&"
export * from "./UsefulContent.vue?vue&type=script&lang=js&"
import style0 from "./UsefulContent.vue?vue&type=style&index=0&id=3389d472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389d472",
  null
  
)

export default component.exports